import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    type: { type: String, default: "line" },
    data: Object,
    options: { type: Object, default: {} },
    currencyAxis: { type: Boolean, default: false }
  }

  connect() {
    this._waitForChart(() => this._render())
  }

  disconnect() {
    if (this._chart) { this._chart.destroy(); this._chart = null }
    if (this._waitTimer) { clearTimeout(this._waitTimer); this._waitTimer = null }
  }

  _waitForChart(callback, attempt = 0) {
    if (typeof Chart !== "undefined") { callback(); return }
    if (attempt >= 40) return // ~4s, desiste em silêncio
    this._waitTimer = setTimeout(() => this._waitForChart(callback, attempt + 1), 100)
  }

  _render() {
    const options = this._buildOptions()
    const ctx = this.element.getContext("2d")
    this._chart = new Chart(ctx, {
      type: this.typeValue,
      data: this.dataValue,
      options: options
    })
  }

  _buildOptions() {
    const options = JSON.parse(JSON.stringify(this.optionsValue))
    if (this.currencyAxisValue) {
      options.scales = options.scales || {}
      options.scales.yAxes = options.scales.yAxes || [{}]
      options.scales.yAxes[0].ticks = Object.assign({ beginAtZero: true }, options.scales.yAxes[0].ticks || {}, {
        callback: (value) => "R$ " + value
      })
    }
    return options
  }
}
